
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Group } from '@/interfaces/Group'
import { MutationTypes } from '@/store/mutation-types'
import TypeSelector from '@/components/TypeSelector.vue'
import LazyImage from '@/components/LazyImage.vue'
import strings from '@/assets/strings.json'

@Component({
  components: {
    LazyImage,
    TypeSelector
  }
})
export default class Step1 extends Vue {
  private groups: Group[] | null = null
  private selectedGroup: Group | null = null

  private typeSelectorStrings = strings.Step1.TypeSelector
  private generalStrings = strings.Generals

  get typeSelectorTitle (): string {
    return this.selectedGroup ? this.typeSelectorStrings.title.replace('%%group%%', this.selectedGroup!.name) : ''
  }

  async created () {
    this.groups = await this.$apiService.getGroups()
  }

  onGroupClick (group: Group) {
    if (group.tags.length > 0) {
      this.selectedGroup = group
      window.VoerroModal.show('typeSelector')
    } else {
      this.$store.commit(MutationTypes.CHANGE_CURRENT_STEP, { currentStep: 1, group })
    }
  }
}
